import request from '@/utils/request'

//列表接口
export function getLogin(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data
  });
}


export function loginAndSavePwd(data) {
  return request({
    url: '/api/loginAndSavePwd',
    method: 'post',
    data
  });
}

export function loginByPwd(data) {
  return request({
    url: '/api/loginByPwd',
    method: 'post',
    data
  });
}

//图形验证码
export function getCaptchaCache(params) {
  return request({
    url: '/api/getSmsCaptcha',
    method: 'get',
    params
  });
}
export function getCaptchaCache1(params) {
  return request({
    url: '/api/getCaptchaCache',
    method: 'get',
    params
  });
}

//图形验证码
export function SendSms(data) {
  return request({
    url: '/api/sendSms',
    method: 'post',
    data
  });
}
//图形验证码
export function SendSmsWithoutCaptcha(data) {
  return request({
    url: '/api/SendSmsWithoutCaptcha',
    method: 'post',
    data
  });
}
export function updatePwd(data) {
  return request({
    url: '/api/updatePwd',
    method: 'post',
    data
  });
}

//观众的个人信息
export function getMe(params) {
  return request({
    url: '/api/me',
    method: 'get',
    params
  });
}
//登出
export function logout(params) {
  return request({
    url: '/api/logout',
    method: 'get',
    params
  });
}
// PC端微信扫码登录
export function wxQrcodeLogin(params) {
  return request({
    url: '/api/wechatlogin/wxQrcodeLogin',
    method: 'get',
    params
  });
}
// PC端微信绑定手机号
export function wxPcBindPhoneNum(data) {
  return request({
    url: '/api/wechatlogin/wxPcBindPhoneNum',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js